export var WindowEvents;
(function (WindowEvents) {
    WindowEvents["Unload"] = "unload";
    WindowEvents["Deviceorientation"] = "deviceorientation";
})(WindowEvents || (WindowEvents = {}));
export var DocumentVisibilityStates;
(function (DocumentVisibilityStates) {
    DocumentVisibilityStates["Hidden"] = "hidden";
    DocumentVisibilityStates["Visible"] = "visible";
})(DocumentVisibilityStates || (DocumentVisibilityStates = {}));
